import { AuthService } from 'app/_services/auth.service';
import { ProductUploadWizardService } from 'app/_services/product-upload-wizard.service';
import { UploadReportResource } from 'app/_resources/upload-report.resource';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';
import { bind } from 'app/_decorators/bind.decorator';
import { mgoAngularWizard } from '../custom';

class UploadWizardNetworkPointComponentCtrl implements ng.IController {
    private wizardCtrl: mgoAngularWizard.Wizard<any>;
    private rawDataId: number;
    public uiLoading: boolean = false;
    private INPUT_ADDON: {};

    constructor(
        private $location: ng.ILocationService,
        private authService: AuthService,
        private networkPointSearchService,
        private productUploadWizardService: ProductUploadWizardService,
        private uploadReportResource: UploadReportResource,
        private errorHandler: ErrorHandler
    ) {
        this.INPUT_ADDON = this.networkPointSearchService.INPUT_ADDON;
    }

    $onInit() {
        if (angular.isUndefined(this.wizardCtrl.context.data.tsoFilter)) {
            this.authService.userLoginPromise.promise.then(
                (loggedInUser) =>
                    (this.wizardCtrl.context.data.tsoFilter = [
                        loggedInUser.tsoName
                    ])
            );
        }
        if (this.rawDataId) {
            this.onEditExistingProduct();
        }
    }

    @bind
    public onNetworkPointSelection(selectedNetworkPoints, isFromQuickfilter) {
        this.wizardCtrl.context.data.selectedNetworkPoint =
            selectedNetworkPoints;
    }

    private onEditExistingProduct() {
        this.uiLoading = true;
        this.uploadReportResource
            .edit(
                { rawDataId: this.rawDataId },
                (res: ManualProductUploadDto) => {
                    this.wizardCtrl.context.transferData =
                        this.productUploadWizardService.mapDataToWizard(
                            res
                        ).transferData;
                    this.wizardCtrl.context.data =
                        this.wizardCtrl.context.transferData[0];
                    this.wizardCtrl.goTo(3);
                },
                this.errorHandler
            )
            .$promise.finally(() => (this.uiLoading = false));
    }

    public cancel(): void {
        this.$location.path('/uploads');
    }

    public submit(isValid): boolean {
        if (!isValid) {
            return false;
        }

        this.wizardCtrl.next();
        return true;
    }

    public cancelAddProduct() {
        if (
            this.wizardCtrl.context.transferData &&
            this.wizardCtrl.context.transferData.length > 0
        ) {
            this.wizardCtrl.context.data =
                this.wizardCtrl.context.transferData[
                    this.wizardCtrl.context.transferData.length - 1
                ];
            this.wizardCtrl.goTo(3);
        }
    }
}

angular.module('app').component('pkpProductUploadWizardNetworkPoint', {
    controller: UploadWizardNetworkPointComponentCtrl,
    template:
        require('app/product-upload-wizard/product-upload-wizard-network-point.component.html'),
    require: {
        wizardCtrl: '^^wizard'
    },
    bindings: {
        rawDataId: '<'
    }
});
